module.exports = __webpack_public_path__ + "static/media/ID.2c3bb5fb.webp";